const FieldRequiredAsterisk = () => (
    <span className="pr-0.5 text-sm font-semibold text-coral-700" role="status">
        *
    </span>
);

export default FieldRequiredAsterisk;
